import instance from '@src/api/common';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

function getJwtToken(customer_key: string, user_email: string) {
  let clId = '';
  const sdkConfigStr = localStorage.getItem('Conviva.sdkConfig');
  if (!sdkConfigStr) {
    console.error('No SDK config found in localStorage');
    return null;
  }
  try {
    const sdkConfig = JSON.parse(sdkConfigStr);
    clId = sdkConfig.clId;
  } catch (error) {
    console.error('Error parsing clid:', error);
    return null;
  }
  return instance.post(`/v1/visual_activation/jwt_token`, {
    client_type: 'web',
    clid: clId,
    customer_key,
    user_email,
  });
}

export const useGetJwtToken = (
  customer_key?: string,
  user_email?: string,
): UseQueryResult<{ token: string }, unknown> => {
  return useQuery(
    ['visual_activation_jwt'],
    async () => {
      const res = await getJwtToken(customer_key!, user_email!);
      console.log('res', res);
      return res?.data?.data;
    },
    {
      enabled: !!customer_key && !!user_email,
    },
  );
};
